import axios from 'axios'
import { host } from '../configuraciones'

//constantes
const dataInicial = {
    data: {
        fc_01_solicitudderegistro: [],
        fc_05_solicitudusomarcaeimagen: [],
        fc_06_registrodemaguey: [],
        fc_08_solicitudrenvacioncertificados: [],
        fc_09_solicitudemicioncertificadonomexportacionyentregahologram: [],
        fc_30_notificaciontrasladodeproducto: [],
        fc_31_solicitudseguimiento: [],
        fc_33_solicitudenvasadonacional: [],
        fc_34_notificacionsuspencionyreactivacion: [],
        fc_35_notificaciondeserviciosvarios: [],
        fc_36_solicituddeactualizacion: [],
        fc_40_solicituddeadquisiciondehologramas: [],
        fc_41_solicitudparabebidasconmezcal: []
    },
    status: 0,
    detalle: {},
    contadorSolicitud:0,
    cliente: [],
    instalacionesCliente:[],
    marcasCliente:[]
}

//types
const OBTENER_SOLICITUDES_STATUS_EXITO = 'OBTENER_SOLICITUDES_STATUS_EXITO'
const OBTENER_SOLICITUDES_ERROR = 'OBTENER_SOLICITUDES_ERROR'
const OBTENER_UNA_SOLICITUID_DETALLE_EXITO = 'OBTENER_UNA_SOLICITUID_DETALLE_EXITO'
const OBTENER_CONTADOR_SOLICITUID_EXITO = 'OBTENER_CONTADOR_SOLICITUID_EXITO'
const OBTENER_CLIENTE_POR_LOGIN_EXITO = 'OBTENER_CLIENTE_POR_LOGIN_EXITO'
const OBTENER_INSTALACIONES_CLIENTE_EXITO = 'OBTENER_INSTALACIONES_CLIENTE_EXITO'
//redcuer
export default function SolicitudesReducer(state = dataInicial, action) {
    switch (action.type) {
        case OBTENER_SOLICITUDES_STATUS_EXITO:
            return { ...state, data: action.payload.data, status: action.payload.status }
        case OBTENER_UNA_SOLICITUID_DETALLE_EXITO:
            return { ...state, detalle: action.payload.detalle }
        case OBTENER_SOLICITUDES_ERROR:
            return { ...state }
            case OBTENER_CONTADOR_SOLICITUID_EXITO:
                // console.log("los datos en reducer ",action.payload )
            return { ...state, contadorSolicitud: action.payload.contadorSolicitud }
        case OBTENER_CLIENTE_POR_LOGIN_EXITO:
            return { ...state, cliente: action.payload.cliente ,marcasCliente:action.payload.marcasCliente}
        case OBTENER_INSTALACIONES_CLIENTE_EXITO:
            return { ...state, instalacionesCliente: action.payload.instalacionesCliente }
        default:
            return state
    }
}


//acciones
export const obtenerSolicitudesWithStatus = (params) => async (dispatch) => {
    try {
        const fullUrl = host + `Estatus/obtenerSolicitudesConEstatus/estatus=${params.status}&idLogin=${params.idLogin}`
        const res = await axios.get(fullUrl)
        // console.log("el resultado es ", res)
        dispatch({
            type: OBTENER_SOLICITUDES_STATUS_EXITO,
            payload: { data: res.data.data, status: params.status }
        })
        return res
    } catch (error) {
        console.log(error)
        dispatch({
            type: OBTENER_SOLICITUDES_ERROR
        })
    }
}
export const obtenerSolicitudesWithStatusProceso = (params) => async (dispatch) => {
    try {
        // console.log("el params es ", params)
        const fullUrl = host + `Estatus/obtenerSolicitudesConEstatusDeProceso/estatus1=${params.status1}&estatus2=${params.status2}&estatus3=${params.status3}&idLogin=${params.idLogin}`
        const res = await axios.get(fullUrl)
        console.log("lo que regresa es ", res.data.data)
        let fc_01_solicitudderegistro = []
        let fc_05_solicitudusomarcaeimagen = []
        let fc_06_registrodemaguey = []
        let fc_08_solicitudrenvacioncertificados = []
        let fc_09_solicitudemicioncertificadonomexportacionyentregahologram = []
        let fc_30_notificaciontrasladodeproducto = []
        let fc_31_solicitudseguimiento = []
        let fc_33_solicitudenvasadonacional = []
        let fc_34_notificacionsuspencionyreactivacion = []
        let fc_35_notificaciondeserviciosvarios = []
        let fc_36_solicituddeactualizacion = []
        let fc_40_solicituddeadquisiciondehologramas = []
        let fc_41_solicitudparabebidasconmezcal = []
        if (res.data.data.fc_01_solicitudderegistro) {
            for( let datos of res.data.data.fc_01_solicitudderegistro){
                for (let i in datos) {
                    fc_01_solicitudderegistro.push(datos[i])
                }
            } 
        }
        if (res.data.data.fc_09_solicitudemicioncertificadonomexportacionyentregahologram) {
            for( let datos of res.data.data.fc_09_solicitudemicioncertificadonomexportacionyentregahologram){
                for (let i in datos) {
                    fc_09_solicitudemicioncertificadonomexportacionyentregahologram.push(datos[i])
                }
            } 
        }
        if (res.data.data.fc_33_solicitudenvasadonacional) {
            for( let datos of res.data.data.fc_33_solicitudenvasadonacional){
                for (let i in datos) {
                    fc_33_solicitudenvasadonacional.push(datos[i])
                }
            } 
        }
        if (res.data.data.fc_30_notificaciontrasladodeproducto) {
            for( let datos of res.data.data.fc_30_notificaciontrasladodeproducto){
                for (let i in datos) {
                    fc_30_notificaciontrasladodeproducto.push(datos[i])
                }
            } 
        }
        if (res.data.data.fc_05_solicitudusomarcaeimagen) {
            for( let datos of res.data.data.fc_05_solicitudusomarcaeimagen){
                for (let i in datos) {
                    fc_05_solicitudusomarcaeimagen.push(datos[i])
                }
            } 
        }
        if (res.data.data.fc_35_notificaciondeserviciosvarios) {
            for( let datos of res.data.data.fc_35_notificaciondeserviciosvarios){
                for (let i in datos) {
                    fc_35_notificaciondeserviciosvarios.push(datos[i])
                }
            } 
        }
        if (res.data.data.fc_06_registrodemaguey) {
            for( let datos of res.data.data.fc_06_registrodemaguey){
                for (let i in datos) {
                    fc_06_registrodemaguey.push(datos[i])
                }
            } 
        }
        if (res.data.data.fc_08_solicitudrenvacioncertificados) {
            for( let datos of res.data.data.fc_08_solicitudrenvacioncertificados){
                for (let i in datos) {
                    fc_08_solicitudrenvacioncertificados.push(datos[i])
                }
            } 
        }
        if (res.data.data.fc_40_solicituddeadquisiciondehologramas) {
            for( let datos of res.data.data.fc_40_solicituddeadquisiciondehologramas){
                for (let i in datos) {
                    fc_40_solicituddeadquisiciondehologramas.push(datos[i])
                }
            } 
        }
        if (res.data.data.fc_34_notificacionsuspencionyreactivacion) {
            for( let datos of res.data.data.fc_34_notificacionsuspencionyreactivacion){
                for (let i in datos) {
                    fc_34_notificacionsuspencionyreactivacion.push(datos[i])
                }
            } 
        }
        if (res.data.data.fc_41_solicitudparabebidasconmezcal) {
            for( let datos of res.data.data.fc_41_solicitudparabebidasconmezcal){
                for (let i in datos) {
                    fc_41_solicitudparabebidasconmezcal.push(datos[i])
                }
            } 
        }
        if (res.data.data.fc_31_solicitudseguimiento) {
            for( let datos of res.data.data.fc_31_solicitudseguimiento){
                for (let i in datos) {
                    fc_31_solicitudseguimiento.push(datos[i])
                }
            } 
        }
        if (res.data.data.fc_36_solicituddeactualizacion) {
            for( let datos of res.data.data.fc_36_solicituddeactualizacion){
                for (let i in datos) {
                    fc_36_solicituddeactualizacion.push(datos[i])
                }
            } 
        }
            
        let solicitudes = []
        solicitudes.push({
            fc_01_solicitudderegistro: fc_01_solicitudderegistro,
            fc_05_solicitudusomarcaeimagen: fc_05_solicitudusomarcaeimagen,
            fc_06_registrodemaguey: fc_06_registrodemaguey,
            fc_08_solicitudrenvacioncertificados: fc_08_solicitudrenvacioncertificados,
            fc_09_solicitudemicioncertificadonomexportacionyentregahologram: fc_09_solicitudemicioncertificadonomexportacionyentregahologram,
            fc_30_notificaciontrasladodeproducto: fc_30_notificaciontrasladodeproducto,
            fc_31_solicitudseguimiento: fc_31_solicitudseguimiento,
            fc_33_solicitudenvasadonacional: fc_33_solicitudenvasadonacional,
            fc_34_notificacionsuspencionyreactivacion: fc_34_notificacionsuspencionyreactivacion,
            fc_35_notificaciondeserviciosvarios: fc_35_notificaciondeserviciosvarios,
            fc_36_solicituddeactualizacion: fc_36_solicituddeactualizacion,
            fc_40_solicituddeadquisiciondehologramas: fc_40_solicituddeadquisiciondehologramas,
            fc_41_solicitudparabebidasconmezcal: fc_41_solicitudparabebidasconmezcal,
        })
        dispatch({
            type: OBTENER_SOLICITUDES_STATUS_EXITO,
            payload: { data: solicitudes[0], status: params.status }
        })
        return res
    } catch (error) {
        console.log(error)
        dispatch({
            type: OBTENER_SOLICITUDES_ERROR
        })
    }
}

export const obetenerSolicitud = (data) => async (dispatch) => {
    try {
        const fullUrl = host + data.row.uri + data.row.solicitudId
        const res = await axios.get(fullUrl)
        dispatch({
            type: OBTENER_UNA_SOLICITUID_DETALLE_EXITO,
            payload: { detalle: res.data.data }
        })
    } catch (error) {
        console.log(error)
        dispatch({
            type: OBTENER_SOLICITUDES_ERROR
        })

    }
}

export const Contadorfc_01PorLogin = (params) => async (dispatch) => {
    try {
        const fullUrl = host + `Estatus/Contadorfc_01PorLogin/idlogin=${params.idlogin}`
        const res = await axios.get(fullUrl)
        dispatch({
            type: OBTENER_CONTADOR_SOLICITUID_EXITO,
            payload: { contadorSolicitud: res.data.data[0].count }
        })
        return res.data.data[0].count
    } catch (error) {
        console.log(error)
    }
}
export const ObtenerClientePorLogin = (params) => async (dispatch) => {
    try {
        const fullUrl = host + `InformacionValida/obtenerClientePorLogin/${params.idlogin}`
        const res = await axios.get(fullUrl)
        let marcas =[]
        marcas.push(res.data.data.marcascliente)
        marcas.push(res.data.data.marcasproductoconmezcalcliente)
        dispatch({
            type: OBTENER_CLIENTE_POR_LOGIN_EXITO,
            payload: { cliente: res.data.data, marcasCliente:marcas}
        })
        return res.data.data.idcliente
    } catch (error) {
        console.log(error)
    }
}
export const ObtenerInstalacionesCliente = (params) => async (dispatch) => {
    try {
        const fullUrl = host + `InformacionValida/obtenerAnexosCliente/${params.idcliente}`
        const res = await axios.get(fullUrl)
        dispatch({
            type: OBTENER_INSTALACIONES_CLIENTE_EXITO,
            payload: { instalacionesCliente: res.data.data}
        })
        return res.data.data.idcliente
    } catch (error) {
        console.log(error)
    }
}